import { UserManagerState } from 'servicesCommon/userManager';

export const getSignInRedirectState = (routeParams: UserManagerState) => {
	if (!routeParams.returnUrl) {
		return {};
	}
	return {
		returnUrl: routeParams.returnUrl,
	};
};
